import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

const faqs = [
  {
    question: 'How can I buy only the features I want?',
    answer: 'Our packaging is built based on the most common use cases from our customers. You can pick one of the packages based on your use case or you can choose the à la carte option to purchase the individual feature(s) you want.',
  },
  {
    question: 'If I pass 10 users, are these first 10 still free?',
    answer: 'No. Your first ten users are free as you demo the product. Once you transition to a paid package, all users within JumpCloud will be billed.',
  },
  {
    question: 'Only a few of my users need a full package, the rest only need directory, is that possible?',
    answer: 'Your package covers the entirety of your JumpCloud account, and you will be charged for all users in your directory according to the package you select.',
  },
  {
    question: 'How can I take over existing local user accounts on my devices?',
    answer: 'Taking over existing local user accounts on devices is easy with the JumpCloud agent. Please read a step-by-step guide here: ',
    externalLink: {
      href: KbArticleUrls.localUserAccount,
      text: 'Taking Over an Existing User Account',
    },
  },
  {
    question: 'How do I get device management only? What package is that?',
    answer: 'Device management is part of the Platform package or Platform Plus package. These packages have been designed to meet the needs of most organizations that use JumpCloud to manage devices as well as other identity management tasks. If you want to build your own package using our A La Carte pricing, please contact sales.',
  },
  {
    question: 'If a user is in a suspended state, is the user still billable?',
    answer: 'Yes. Suspended users are retained in the system during the time they are suspended and are billed as normal users.',
  },
  {
    question: 'Monthly vs Annual billing: If I start with monthly billing, can I switch to annual in the future?',
    answer: 'Yes, you can start with monthly billing and then contact sales to switch to annual at any time in the future.',
  },
  {
    question: 'What forms of payment does JumpCloud accept?',
    answer: 'We accept credit cards (American Express, Discover, MasterCard, and Visa) and ACH transfers. For accounts billing greater than $1,000 per month, invoicing is possible.',
  },
  {
    question: 'When does JumpCloud bill?',
    answer: 'We bill accounts on the 1st of each month for the previous month. Note that you will always receive service for the number of days in your contract.',
  },
];

export default { faqs };
